//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "jquery",
  "marionette",
  "underscore",
  "messaging/messenger",
  "./template/taskStepsTemplate.html",
  "./template/taskStepTemplate.html",
], function ($, Marionette, _, Messenger, TaskStepsTemplate, TaskStepTemplate) {
  "use strict";

  const TaskStepView = {};

  TaskStepView.stepView = Marionette.ItemView.extend({
    template: TaskStepTemplate,
    tagName: "tr",
    className: "task-step",
    templateHelpers: function () {
      const languages = Messenger.reqres.request("kb:languages");
      const statuses = Messenger.reqres.request("task:statuses");
      const allUsers = $.t("task.step.allUsers");

      return {
        getDepartments: function () {
          const assignees = this._thisObject.assignees();
          if (!assignees || !assignees.length) {
            return "";
          }
          return assignees
            .map(function (assignee) {
              return assignee.get("departmentName");
            })
            .join(", ");
        },
        getLocaleName: function (localeId) {
          const language = languages.get(localeId);
          if (language) {
            return language.get("name");
          }
          return "";
        },
        getStatusName: function (statusId) {
          const status = statuses.get(statusId);
          if (status) {
            return status.get("text");
          }
          return "";
        },
        getUsers: function () {
          const assignees = this._thisObject.assignees();
          if (!assignees || !assignees.length) {
            return "";
          }
          return assignees
            .map(function (assignee) {
              if (assignee.get("allUsers")) {
                return allUsers;
              }
              return assignee.get("userName");
            })
            .join(", ");
        },
      };
    },
  });

  TaskStepView.stepsView = Marionette.CompositeView.extend({
    template: TaskStepsTemplate,
    itemView: TaskStepView.stepView,
    itemViewContainer: "tbody",
  });

  return TaskStepView;
});
